module.exports = __webpack_public_path__ + "img/ogp.103330e.jpg";